<template>
  <span class="srm-month-picker">
    <a-month-picker
      :disabledDate="disabledStartDate"
      :size="size"
      :placeholder="param.placeholder[0]"
      :style="param.style"
      showTime
      format="YYYY-MM"
      v-model="param.value[0]"
      @openChange="handleStartOpenChange"
    />
    <a-month-picker
      class="end-month"
      :disabledDate="disabledEndDate"
      :size="size"
      :placeholder="param.placeholder[1]"
      :style="param.style"
      showTime
      format="YYYY-MM"
      v-model="param.value[1]"
      :open="endOpen"
      @openChange="handleEndOpenChange"
    />
  </span>
</template>

<script>
export default {
  props: {
    param: Object,
    size: String,
  },
  data() {
    return {
      endOpen: false,
    }
  },
  methods: {
    disabledStartDate(startValue) {
      const endValue = this.param.value[1];
      if (!startValue || !endValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },
    disabledEndDate(endValue) {
      const startValue = this.param.value[0];
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() >= endValue.valueOf();
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true;
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open;
    },
  },
}
</script>
<style lang="less">
.srm-month-picker {
  .end-month {
    margin-left: -5px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/srm-search/srm-month-picker.vue